/**
 * Сгруппировал здесь ссылки на приложение iOS.
 */

export const openMambaAppOtpReload = () =>
  window.location.assign('mmb://otp/reload')

export const openMambaAppOtpResult = (ok: boolean, orderId: string) =>
  window.location.assign(`mmb://otp/?success=${ok}&orderid=${orderId}`)
